import { SubjectTypeCustomFieldModel } from '../subjectTypeCustomField/subjectTypeCustomFieldModel';

export class SubjectTypeModel {
    public id: number;
    public name: string;
    public description: string;
    public caseTypeIds: number[];
    public subjectTypeCustomFields: SubjectTypeCustomFieldModel[];
}
